import { components } from "@/api-schema";
import { formatDateToLocale } from "@/common/helpers/format-date";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import { EmptyValue } from "@/components/ui/empty-value";
import { commonColumns } from "./_constants/common-columns";

type GroupTableType = components["schemas"]["Group"];

export const groupTableDefaultColumns = {
  columnName: {
    ...commonColumns.columnName<GroupTableType>(),
    size: 500,
  } as ImplementedAccessorColumnDef<GroupTableType>,
  columnDeletedAt: {
    ...commonColumns.columnDeletedAt<GroupTableType>(),
    cell: (row) => {
      const date = row.getValue() as string;
      return <div className={date ? "text-error" : ""}>{date ? formatDateToLocale(date) : <EmptyValue />}</div>;
    },
  } as ImplementedAccessorColumnDef<GroupTableType>,
  columnUuid: commonColumns.columnUuid<GroupTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<GroupTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<GroupTableType>(),
};
